import environmentConfig from "configuration/environmentConfig";

const helpCenterLink = environmentConfig.helpCenterUrl;
const helpCenterRelativeUrls = environmentConfig.helpCenterRelativeUrls;

export const getSourceTooltipMessage = () => {
  const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.embeddingAVideoURL}`;
  return (
    <>
      Select a video source for your video. See this{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        help article
      </a>{" "}
      for details.
    </>
  );
};

export const getVideoUrlTooltipMessage = () => {
  const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.embeddingAVideoURL}`;
  return (
    <>
      Enter a video URL from YouTube, Vimeo, or Wistia. See this{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        help article
      </a>{" "}
      for details.
    </>
  );
};
